
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 3a9 9 0 106.427 2.636l1.414-1.414h-4.243v4.242l1.414-1.414A7 7 0 1112 5V3z"}}),_c('path',{attrs:{"d":"M12.997 11.583V6.997h-2v5.415l3.796 3.795 1.414-1.414-3.21-3.21z"}})])
          )
        }
      }
    